<template>
	<div>
		<table cellpadding="0" cellspacing="0" class="data  transition-fadeinup">
			<thead>
			<tr>
				<th></th>
				<th><h2>Group by template</h2></th>
				<th></th>
			</tr>
			</thead>

			<tbody>

				<template v-for="(type, key) in templates">
						<tr class="title" :key="key">
							<td></td>
							<td><h3>{{ key }}</h3></td>
							<td></td>
							<td></td>
						</tr>

					<template v-for="template in type">

						<tr :key="template">
							<td></td>

							<td>{{ stripExtension(template) }}</td>

							<td class="btns">
								<a href="#" v-on:click="openSidebar" :data-template="key + '/' + template"><i class="fa fa-th-list"></i></a>
							</td>
							<td></td>
						</tr>

					</template>
				</template>

			</tbody>

		</table>

		<Sidebar :type="'translations'" ref="sidebar" :data="dataWrapper"></Sidebar>
	</div>

</template>

<script>

import Sidebar from '../../components/sidebars/Sidebar.vue'
import xhrModule from '../../modules/xhrModule.js'

export default {
	name: 'translations',
	components: {
		'Sidebar': Sidebar
	},
	data () {
		return {
			entityID: 27,
			renderInt: 0,
			templates: {},
			defaultLang: null,
			fragments: null,
			dataWrapper: {
				marketOffsetTop: null,
				languages: null,
				entity: null,
				template: null,
				fragments: null
			}
		}
	},

	created () {
		this.fetchData()
	},

	methods: {
		fetchData () {
			document.querySelector('body').classList.add('loading')
			// markets
			var url = '/cms/api/markets'
			xhrModule.get(url, this.fetchMarketsComplete.bind(this))

			// entity
			var url2 = '/cms/api/entities?id=' + this.entityID
			xhrModule.get(url2, this.getEntityCompleteHandler.bind(this))

			// fragments
			var url3 = '/cms/api/instances/fragments'
			xhrModule.get(url3, this.fetchFragmentsCompleted.bind(this))
		},

		fetchMarketsComplete: function (data) {
			// remove cms language
			delete data.data[1]
			this.defaultLang = data.data[Object.keys(data.data)[0]]
			this.dataWrapper.languages = data.data

			this.render()
		},

		fetchFragmentsCompleted (data) {
			this.fragments = data.data
			this.dataWrapper.fragments = data.data
			this.render()
		},

		getEntityCompleteHandler (entity) {
			this.dataWrapper.entity = entity.data
			this.render()
		},

		render () {
			this.renderInt++
			if (this.renderInt === 3) {
				if (this.fragments.length === 0) {
					document.querySelector('body').classList.remove('loading')
					this.$forceUpdate()
				}

				var tempTemplates = []
				// get all unique templates from the fragments
				for (var f = this.fragments.length - 1; f >= 0; f--) {
					var templates = this.fragments[f].templates
					if (templates) {
						for (var t = templates.length - 1; t >= 0; t--) {
							if (!tempTemplates.includes(templates[t])) {
								tempTemplates.push(templates[t])
							}
						}
					}

					if (f === 0) {
						// sort templates by type
						for (var i = tempTemplates.length - 1; i >= 0; i--) {
							var type = tempTemplates[i].split('/')[0]

							// feeds cannot contain translations
							if (type === 'feeds') continue

							var template = tempTemplates[i].split('/')[1]
							if (!this.templates[type]) this.templates[type] = []
							this.templates[type].push(template)

							if (i === 0) {
								// sort alphabetically
								for (var key in this.templates) {
									this.templates[key].sort()
								}

								document.querySelector('body').classList.remove('loading')
								this.$forceUpdate()
							}
						}
					}
				}
			}
		},

		openSidebar (e) {
			e.preventDefault()

			var template = e.currentTarget.getAttribute('data-template')
			this.dataWrapper.template = template

			// find the offset top for the marker in the sidebar
			this.dataWrapper.marketOffsetTop = e.currentTarget.getBoundingClientRect().top + (e.currentTarget.getBoundingClientRect().height / 2) - 9

			this.$refs.sidebar.toggle(e.currentTarget)
		}
	}
}

</script>
